// A bot's bee as a PNG, for pictures outside the page: Android's notifications and icon
// shortcuts (native/botFaces.js) and the desktop app's system notifications (desktop/).
// The bee is drawn only in beeSvg.js; this rasterises it on a dark disc, the way the bees
// are drawn for dark surfaces.
import { HONEY, PALETTES, beeInner } from './beeSvg';

export const FACE_PX = 216;          // Android's adaptive bitmap (BotConversations.SIZE)
export const FACE_BG = '#24211c';
const BEE_SHARE = 0.62;              // inside the circle Android keeps of an adaptive bitmap

export const faceSvg = ({ species, color }, px = FACE_PX, palette = PALETTES.dark) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 102 102" width="${px}" height="${px}">${
  beeInner({ species, color: color || HONEY, state: 'idle', palette, uid: 'face' })}</svg>`;

/**
 * The bee on a dark square (masked to a circle by whoever shows it), as base64 PNG. A menu
 * icon (the desktop tray) passes background: null and the palette of the system's theme.
 */
export function beePng(face, { px = FACE_PX, share = BEE_SHARE, background = FACE_BG, palette = PALETTES.dark } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(new Blob([faceSvg(face, px, palette)], { type: 'image/svg+xml' }));
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = px;
      canvas.height = px;
      const ctx = canvas.getContext('2d');
      if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, px, px);
      }
      const side = px * share;
      ctx.drawImage(img, (px - side) / 2, (px - side) / 2, side, side);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/png').split(',')[1]);
    };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}
